export default __webpack_public_path__ + "static/media/section-bg-submit.video-mobile.e38f1cc8.jpg";